/**
 * @generated SignedSource<<204349fbd686e09aee2c97645eec0b3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TrainingSourceKind = "knowledge_base" | "web_crawl" | "%future added value";
export type WebCrawlScope = "domain" | "single_page" | "subpath" | "%future added value";
export type CreateTrainingSourceInput = {
  expect?: string | null;
  kind: TrainingSourceKind;
  name?: string | null;
  organizationId: string;
  resync?: boolean | null;
  url: string;
  webCrawlConfig?: WebCrawlConfigInput | null;
};
export type WebCrawlConfigInput = {
  excludeUrlGlobs?: ReadonlyArray<string> | null;
  includeUrlGlobs?: ReadonlyArray<string> | null;
  scope?: WebCrawlScope | null;
};
export type TrainingSourceSettingsForm__createMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateTrainingSourceInput;
  kind: TrainingSourceKind;
};
export type TrainingSourceSettingsForm__createMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
      readonly organization: {
        readonly trainingDataCount: number;
      };
      readonly " $fragmentSpreads": FragmentRefs<"TrainingSourceListItemFragment" | "TrainingSourceTableListItemFragment">;
    } | null;
  };
};
export type TrainingSourceSettingsForm__createMutation = {
  response: TrainingSourceSettingsForm__createMutation$data;
  variables: TrainingSourceSettingsForm__createMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "kind"
},
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "items": [
        {
          "kind": "Variable",
          "name": "kinds.0",
          "variableName": "kind"
        }
      ],
      "kind": "ListValue",
      "name": "kinds"
    }
  ],
  "kind": "ScalarField",
  "name": "trainingDataCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TrainingSourceSettingsForm__createMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v3/*: any*/),
        "concreteType": "CreateTrainingSourceResponse",
        "kind": "LinkedField",
        "name": "createTrainingSource",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TrainingSource",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TrainingSourceListItemFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TrainingSourceTableListItemFragment"
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "TrainingSourceSettingsForm__createMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v3/*: any*/),
        "concreteType": "CreateTrainingSourceResponse",
        "kind": "LinkedField",
        "name": "createTrainingSource",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TrainingSource",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "kind",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TrainingSourceMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TrainingSourceWebCrawlMetadata",
                    "kind": "LinkedField",
                    "name": "web_crawl",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WebCrawlConfig",
                        "kind": "LinkedField",
                        "name": "config",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scope",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "excludeUrlGlobs",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "requests",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TrainingDataNodeConnection",
                "kind": "LinkedField",
                "name": "trainingData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TrainingDataNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TrainingData",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v8/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "textContent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TrainingDataMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TrainingDataWebCrawlMetadata",
                                "kind": "LinkedField",
                                "name": "web_crawl",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "title",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resyncPeriod",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "node",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "TrainingSourceNodeEdge"
              }
            ]
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5f45f467167ac6d906678af50e8fde20",
    "id": null,
    "metadata": {},
    "name": "TrainingSourceSettingsForm__createMutation",
    "operationKind": "mutation",
    "text": "mutation TrainingSourceSettingsForm__createMutation(\n  $input: CreateTrainingSourceInput!\n  $kind: TrainingSourceKind!\n) {\n  response: createTrainingSource(input: $input) {\n    node {\n      id\n      organization {\n        trainingDataCount(kinds: [$kind])\n        id\n      }\n      ...TrainingSourceListItemFragment\n      ...TrainingSourceTableListItemFragment\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment TrainingSourceListItemFragment on TrainingSource {\n  id\n  status\n  kind\n  url\n  metadata {\n    web_crawl {\n      config {\n        scope\n      }\n      requests\n    }\n  }\n  trainingData {\n    totalCount\n    edges {\n      node {\n        id\n        name\n        url\n        textContent\n        metadata {\n          web_crawl {\n            title\n          }\n        }\n      }\n    }\n  }\n  ...TrainingSourceSettingsFormFragment\n}\n\nfragment TrainingSourceSettingsFormFragment on TrainingSource {\n  id\n  kind\n  url\n  name\n  resyncPeriod\n  metadata {\n    web_crawl {\n      config {\n        scope\n        excludeUrlGlobs\n      }\n    }\n  }\n}\n\nfragment TrainingSourceTableListItemFragment on TrainingSource {\n  id\n  name\n  status\n  kind\n  createdAt\n  url\n  trainingData {\n    totalCount\n  }\n  ...TrainingSourceSettingsFormFragment\n}\n"
  }
};
})();

(node as any).hash = "6b9c78f4527ce49f2f78a762d7d06b57";

export default node;
